import { Route } from '@angular/router';
import { TermsComponent } from './terms.component';
export const TermsRoutes: Route[] = [
  {
    path: 'termsV1.html',
    component: TermsComponent
  }
];
